export class ImprovementsConfig {
  managerUrl = '';
  apiUrl = '';
  maxContractConfig = { key: '', iv: '' };
  appName? = '';
}
